@if (rows().length) {
  <iris-card>
    <div class="card-header" data-dd-privacy="allow">
      <h2 id="va-auth-heading" class="card-heading" data-test="va-authorizations">VA Authorizations</h2>
    </div>

    <table class="va-auth-table" aria-labelledby="va-auth-heading">
      <thead>
        <tr>
          <th scope="col">Authorization Number</th>
          <th scope="col">Care Type</th>
          <th scope="col">Start &amp; End Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track $index) {
          <tr data-test="va-auth-row">
            <td>{{ row.authNumber }}</td>
            <td>{{ row.careType }}</td>
            <td>{{ row.dateRange }}</td>
            <td>
              <span class="status-badge" [class]="row.badgeClass" data-test="va-auth-status">
                {{ row.statusLabel }}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </iris-card>
}
